import { render, staticRenderFns } from "./member_jf_supdeduct_list.vue?vue&type=template&id=68aa5e2c"
import script from "./member_jf_supdeduct_list.vue?vue&type=script&lang=js"
export * from "./member_jf_supdeduct_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports